export const GET_ALL_BANK_DETAILS = 'GET_ALL_BANK_DETAILS'
export const GET_BANK_DETAILS = 'GET_BANK_DETAILS'
export const RESPONSE_STATUS = 'RESPONSE_STATUS'
export const CLEAR_RESPONSE = 'CLEAR_RESPONSE'
